(function () {
  const sel = '[data-configurator]';

  function onReady(fn){
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  async function fetchPage(handle, page){
    const res = await fetch(`/collections/${handle}?view=configurator-json&page=${page}`, {credentials:'same-origin'});
    if(!res.ok) return null;
    return res.json();
  }

  async function loadIndex(handle){
    const all = [];
    let p = 1;
    while(true){
      const json = await fetchPage(handle, p);
      if(!json || !json.products || !json.products.length) break;
      all.push(...json.products);
      if(p >= json.pages) break;
      p++;
    }
    return all;
  }

  // Only keep values that appear at least once among siblings (Dawn behavior)
  function existingValues(products, groupLabel){
    const s = new Set();
    for(const p of products){
      const v = p.groups && p.groups[groupLabel];
      if(v && String(v).trim() !== '') s.add(String(v).trim());
    }
    return s;
  }

  function readSelections(wrapper){
    const map = {};
    wrapper.querySelectorAll('[data-config-group]').forEach(w=>{
      const g = w.getAttribute('data-config-group');
      const hidden = w.querySelector(`[data-config-hidden="${g}"]`);
      if(hidden) map[g] = hidden.value;
    });
    return map;
  }

  function scoreProduct(p, wanted){
    let score = 0;
    for(const g of Object.keys(wanted)){
      const want = wanted[g];
      const got  = (p.groups && p.groups[g]) || null;
      if(!want) continue;
      if(!got) { score += 2; continue; }
      if(String(want) !== String(got)) score += 1;
    }
    return score;
  }

  function bestMatch(products, wanted){
    let best = null, bestScore = Infinity;
    for(const p of products){
      const s = scoreProduct(p, wanted);
      if(s < bestScore){ best = p; bestScore = s; }
      if(bestScore === 0) break;
    }
    return best;
  }

  async function swapSection(url, sectionId){
    const res = await fetch(`${url}?section_id=${sectionId}`, {credentials:'same-origin'});
    if(!res.ok) return false;
    const html = await res.text();
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const incoming = tmp.querySelector(`#shopify-section-${sectionId}`);
    const current  = document.querySelector(`#shopify-section-${sectionId}`);
    if(!incoming || !current) return false;
    current.replaceWith(incoming);

    // Re-fire apps you mentioned
    try { window.dispatchEvent(new CustomEvent('mr:productChange')); } catch(e){}
    try { window.LiveOptions && typeof window.LiveOptions.refresh === 'function' && window.LiveOptions.refresh(); } catch(e){}

    // Ensure "id" input is enabled
    document.querySelectorAll('form[is="product-form"] input[name="id"]').forEach(i=>{ i.disabled = false; });
    return true;
  }

  function applySelection(groupWrap, value){
    const label = groupWrap.querySelector('[data-config-button-label]');
    const valSpan = groupWrap.querySelector('[data-config-value-label]');
    const hidden = groupWrap.querySelector(`[data-config-hidden="${groupWrap.getAttribute('data-config-group')}"]`);
    if(label) label.textContent = value;
    if(valSpan) valSpan.textContent = value;
    if(hidden) hidden.value = value;
    groupWrap.querySelectorAll('.combo-box__option-item').forEach(btn=>{
      btn.setAttribute('aria-selected', String(btn.getAttribute('data-config-value') === value));
    });
  }

  onReady(async function(){
    const wrappers = document.querySelectorAll(sel);
    if(!wrappers.length) return;

    for(const wrap of wrappers){
      const metaTag = document.querySelector('script[type="application/json"][data-configurator-meta]');
      if(!metaTag) continue;
      const meta = JSON.parse(metaTag.textContent);
      const collectionHandle = wrap.getAttribute('data-collection-handle');
      const sectionId = meta.sectionId;

      const products = await loadIndex(collectionHandle);

      // FILTER OPTIONS to only values that exist among siblings
      wrap.querySelectorAll('[data-config-group]').forEach(groupWrap=>{
        const g = groupWrap.getAttribute('data-config-group');
        const allowed = existingValues(products, g);
        groupWrap.querySelectorAll('.combo-box__option-item').forEach(btn=>{
          const v = btn.getAttribute('data-config-value');
          if(!allowed.has(v)) btn.classList.add('is-disabled');
        });
      });

      // Bind clicks
      wrap.querySelectorAll('.combo-box__option-item').forEach(btn=>{
        btn.addEventListener('click', async (e)=>{
          e.preventDefault();
          const groupWrap = e.currentTarget.closest('[data-config-group]');
          const value = e.currentTarget.getAttribute('data-config-value');
          applySelection(groupWrap, value);

          const desired = readSelections(wrap);
          const match = bestMatch(products, desired);
          if(!match || !match.url) return;
          const ok = await swapSection(match.url, sectionId);
          if(!ok) window.location = match.url;
        });
      });

      // Make sure the hidden variant id is enabled for ATC
      document.querySelectorAll('form[is="product-form"] input[name="id"]').forEach(i=>{ i.disabled = false; });
    }
  });
})();
